var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { colors } from '../../../abstracts';
export var DrawerHandle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 52px;\n  min-height: 4px;\n  z-index: 1000;\n  margin-bottom: 6px;\n  margin-top: 15px;\n  border-radius: 10px;\n  background: ", ";\n"], ["\n  width: 52px;\n  min-height: 4px;\n  z-index: 1000;\n  margin-bottom: 6px;\n  margin-top: 15px;\n  border-radius: 10px;\n  background: ", ";\n"])), colors.neutralBrighter);
var templateObject_1;
